/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as MonitorRouteImport } from './routes/monitor'
import { Route as R404RouteImport } from './routes/404'
import { Route as DashboardRouteRouteImport } from './routes/dashboard/route'
import { Route as AuthRouteRouteImport } from './routes/auth/route'
import { Route as ArcRouteRouteImport } from './routes/arc/route'
import { Route as IndexRouteImport } from './routes/index'
import { Route as ArcIndexRouteImport } from './routes/arc/index'
import { Route as ArcSipRouteImport } from './routes/arc/_sip'
import { Route as AuthSignUpRouteRouteImport } from './routes/auth/sign-up/route'
import { Route as AuthSignInRouteRouteImport } from './routes/auth/sign-in/route'
import { Route as AuthResetPasswordRouteRouteImport } from './routes/auth/reset-password/route'
import { Route as ArcOfflineRouteRouteImport } from './routes/arc/offline/route'
import { Route as AuthCallbackMicrosoftRouteImport } from './routes/auth/callback/microsoft'
import { Route as ArcSipStatisticsRouteRouteImport } from './routes/arc/_sip/statistics/route'
import { Route as ArcSipProfileRouteRouteImport } from './routes/arc/_sip/profile/route'
import { Route as ArcSipCallRouteRouteImport } from './routes/arc/_sip/call/route'
import { Route as ArcSipAdminRouteRouteImport } from './routes/arc/_sip/admin/route'
import { Route as ArcSipCallAvailableRouteImport } from './routes/arc/_sip/call/available'
import { Route as ArcSipCallCallingRouteRouteImport } from './routes/arc/_sip/call/calling/route'

const MonitorRoute = MonitorRouteImport.update({
  id: '/monitor',
  path: '/monitor',
  getParentRoute: () => rootRouteImport,
} as any)
const R404Route = R404RouteImport.update({
  id: '/404',
  path: '/404',
  getParentRoute: () => rootRouteImport,
} as any)
const DashboardRouteRoute = DashboardRouteRouteImport.update({
  id: '/dashboard',
  path: '/dashboard',
  getParentRoute: () => rootRouteImport,
} as any)
const AuthRouteRoute = AuthRouteRouteImport.update({
  id: '/auth',
  path: '/auth',
  getParentRoute: () => rootRouteImport,
} as any)
const ArcRouteRoute = ArcRouteRouteImport.update({
  id: '/arc',
  path: '/arc',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const ArcIndexRoute = ArcIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => ArcRouteRoute,
} as any)
const ArcSipRoute = ArcSipRouteImport.update({
  id: '/_sip',
  getParentRoute: () => ArcRouteRoute,
} as any)
const AuthSignUpRouteRoute = AuthSignUpRouteRouteImport.update({
  id: '/sign-up',
  path: '/sign-up',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthSignInRouteRoute = AuthSignInRouteRouteImport.update({
  id: '/sign-in',
  path: '/sign-in',
  getParentRoute: () => AuthRouteRoute,
} as any)
const AuthResetPasswordRouteRoute = AuthResetPasswordRouteRouteImport.update({
  id: '/reset-password',
  path: '/reset-password',
  getParentRoute: () => AuthRouteRoute,
} as any)
const ArcOfflineRouteRoute = ArcOfflineRouteRouteImport.update({
  id: '/offline',
  path: '/offline',
  getParentRoute: () => ArcRouteRoute,
} as any)
const AuthCallbackMicrosoftRoute = AuthCallbackMicrosoftRouteImport.update({
  id: '/callback/microsoft',
  path: '/callback/microsoft',
  getParentRoute: () => AuthRouteRoute,
} as any)
const ArcSipStatisticsRouteRoute = ArcSipStatisticsRouteRouteImport.update({
  id: '/statistics',
  path: '/statistics',
  getParentRoute: () => ArcSipRoute,
} as any)
const ArcSipProfileRouteRoute = ArcSipProfileRouteRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => ArcSipRoute,
} as any)
const ArcSipCallRouteRoute = ArcSipCallRouteRouteImport.update({
  id: '/call',
  path: '/call',
  getParentRoute: () => ArcSipRoute,
} as any)
const ArcSipAdminRouteRoute = ArcSipAdminRouteRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => ArcSipRoute,
} as any)
const ArcSipCallAvailableRoute = ArcSipCallAvailableRouteImport.update({
  id: '/available',
  path: '/available',
  getParentRoute: () => ArcSipCallRouteRoute,
} as any)
const ArcSipCallCallingRouteRoute = ArcSipCallCallingRouteRouteImport.update({
  id: '/calling',
  path: '/calling',
  getParentRoute: () => ArcSipCallRouteRoute,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/arc': typeof ArcSipRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRoute
  '/404': typeof R404Route
  '/monitor': typeof MonitorRoute
  '/arc/offline': typeof ArcOfflineRouteRoute
  '/auth/reset-password': typeof AuthResetPasswordRouteRoute
  '/auth/sign-in': typeof AuthSignInRouteRoute
  '/auth/sign-up': typeof AuthSignUpRouteRoute
  '/arc/': typeof ArcIndexRoute
  '/arc/admin': typeof ArcSipAdminRouteRoute
  '/arc/call': typeof ArcSipCallRouteRouteWithChildren
  '/arc/profile': typeof ArcSipProfileRouteRoute
  '/arc/statistics': typeof ArcSipStatisticsRouteRoute
  '/auth/callback/microsoft': typeof AuthCallbackMicrosoftRoute
  '/arc/call/calling': typeof ArcSipCallCallingRouteRoute
  '/arc/call/available': typeof ArcSipCallAvailableRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRoute
  '/404': typeof R404Route
  '/monitor': typeof MonitorRoute
  '/arc/offline': typeof ArcOfflineRouteRoute
  '/auth/reset-password': typeof AuthResetPasswordRouteRoute
  '/auth/sign-in': typeof AuthSignInRouteRoute
  '/auth/sign-up': typeof AuthSignUpRouteRoute
  '/arc': typeof ArcIndexRoute
  '/arc/admin': typeof ArcSipAdminRouteRoute
  '/arc/call': typeof ArcSipCallRouteRouteWithChildren
  '/arc/profile': typeof ArcSipProfileRouteRoute
  '/arc/statistics': typeof ArcSipStatisticsRouteRoute
  '/auth/callback/microsoft': typeof AuthCallbackMicrosoftRoute
  '/arc/call/calling': typeof ArcSipCallCallingRouteRoute
  '/arc/call/available': typeof ArcSipCallAvailableRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/arc': typeof ArcRouteRouteWithChildren
  '/auth': typeof AuthRouteRouteWithChildren
  '/dashboard': typeof DashboardRouteRoute
  '/404': typeof R404Route
  '/monitor': typeof MonitorRoute
  '/arc/offline': typeof ArcOfflineRouteRoute
  '/auth/reset-password': typeof AuthResetPasswordRouteRoute
  '/auth/sign-in': typeof AuthSignInRouteRoute
  '/auth/sign-up': typeof AuthSignUpRouteRoute
  '/arc/_sip': typeof ArcSipRouteWithChildren
  '/arc/': typeof ArcIndexRoute
  '/arc/_sip/admin': typeof ArcSipAdminRouteRoute
  '/arc/_sip/call': typeof ArcSipCallRouteRouteWithChildren
  '/arc/_sip/profile': typeof ArcSipProfileRouteRoute
  '/arc/_sip/statistics': typeof ArcSipStatisticsRouteRoute
  '/auth/callback/microsoft': typeof AuthCallbackMicrosoftRoute
  '/arc/_sip/call/calling': typeof ArcSipCallCallingRouteRoute
  '/arc/_sip/call/available': typeof ArcSipCallAvailableRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/arc'
    | '/auth'
    | '/dashboard'
    | '/404'
    | '/monitor'
    | '/arc/offline'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/arc/'
    | '/arc/admin'
    | '/arc/call'
    | '/arc/profile'
    | '/arc/statistics'
    | '/auth/callback/microsoft'
    | '/arc/call/calling'
    | '/arc/call/available'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/auth'
    | '/dashboard'
    | '/404'
    | '/monitor'
    | '/arc/offline'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/arc'
    | '/arc/admin'
    | '/arc/call'
    | '/arc/profile'
    | '/arc/statistics'
    | '/auth/callback/microsoft'
    | '/arc/call/calling'
    | '/arc/call/available'
  id:
    | '__root__'
    | '/'
    | '/arc'
    | '/auth'
    | '/dashboard'
    | '/404'
    | '/monitor'
    | '/arc/offline'
    | '/auth/reset-password'
    | '/auth/sign-in'
    | '/auth/sign-up'
    | '/arc/_sip'
    | '/arc/'
    | '/arc/_sip/admin'
    | '/arc/_sip/call'
    | '/arc/_sip/profile'
    | '/arc/_sip/statistics'
    | '/auth/callback/microsoft'
    | '/arc/_sip/call/calling'
    | '/arc/_sip/call/available'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  ArcRouteRoute: typeof ArcRouteRouteWithChildren
  AuthRouteRoute: typeof AuthRouteRouteWithChildren
  DashboardRouteRoute: typeof DashboardRouteRoute
  R404Route: typeof R404Route
  MonitorRoute: typeof MonitorRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/monitor': {
      id: '/monitor'
      path: '/monitor'
      fullPath: '/monitor'
      preLoaderRoute: typeof MonitorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/404': {
      id: '/404'
      path: '/404'
      fullPath: '/404'
      preLoaderRoute: typeof R404RouteImport
      parentRoute: typeof rootRouteImport
    }
    '/dashboard': {
      id: '/dashboard'
      path: '/dashboard'
      fullPath: '/dashboard'
      preLoaderRoute: typeof DashboardRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/auth': {
      id: '/auth'
      path: '/auth'
      fullPath: '/auth'
      preLoaderRoute: typeof AuthRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arc': {
      id: '/arc'
      path: '/arc'
      fullPath: '/arc'
      preLoaderRoute: typeof ArcRouteRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/arc/': {
      id: '/arc/'
      path: '/'
      fullPath: '/arc/'
      preLoaderRoute: typeof ArcIndexRouteImport
      parentRoute: typeof ArcRouteRoute
    }
    '/arc/_sip': {
      id: '/arc/_sip'
      path: ''
      fullPath: '/arc'
      preLoaderRoute: typeof ArcSipRouteImport
      parentRoute: typeof ArcRouteRoute
    }
    '/auth/sign-up': {
      id: '/auth/sign-up'
      path: '/sign-up'
      fullPath: '/auth/sign-up'
      preLoaderRoute: typeof AuthSignUpRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/sign-in': {
      id: '/auth/sign-in'
      path: '/sign-in'
      fullPath: '/auth/sign-in'
      preLoaderRoute: typeof AuthSignInRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/auth/reset-password': {
      id: '/auth/reset-password'
      path: '/reset-password'
      fullPath: '/auth/reset-password'
      preLoaderRoute: typeof AuthResetPasswordRouteRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/arc/offline': {
      id: '/arc/offline'
      path: '/offline'
      fullPath: '/arc/offline'
      preLoaderRoute: typeof ArcOfflineRouteRouteImport
      parentRoute: typeof ArcRouteRoute
    }
    '/auth/callback/microsoft': {
      id: '/auth/callback/microsoft'
      path: '/callback/microsoft'
      fullPath: '/auth/callback/microsoft'
      preLoaderRoute: typeof AuthCallbackMicrosoftRouteImport
      parentRoute: typeof AuthRouteRoute
    }
    '/arc/_sip/statistics': {
      id: '/arc/_sip/statistics'
      path: '/statistics'
      fullPath: '/arc/statistics'
      preLoaderRoute: typeof ArcSipStatisticsRouteRouteImport
      parentRoute: typeof ArcSipRoute
    }
    '/arc/_sip/profile': {
      id: '/arc/_sip/profile'
      path: '/profile'
      fullPath: '/arc/profile'
      preLoaderRoute: typeof ArcSipProfileRouteRouteImport
      parentRoute: typeof ArcSipRoute
    }
    '/arc/_sip/call': {
      id: '/arc/_sip/call'
      path: '/call'
      fullPath: '/arc/call'
      preLoaderRoute: typeof ArcSipCallRouteRouteImport
      parentRoute: typeof ArcSipRoute
    }
    '/arc/_sip/admin': {
      id: '/arc/_sip/admin'
      path: '/admin'
      fullPath: '/arc/admin'
      preLoaderRoute: typeof ArcSipAdminRouteRouteImport
      parentRoute: typeof ArcSipRoute
    }
    '/arc/_sip/call/available': {
      id: '/arc/_sip/call/available'
      path: '/available'
      fullPath: '/arc/call/available'
      preLoaderRoute: typeof ArcSipCallAvailableRouteImport
      parentRoute: typeof ArcSipCallRouteRoute
    }
    '/arc/_sip/call/calling': {
      id: '/arc/_sip/call/calling'
      path: '/calling'
      fullPath: '/arc/call/calling'
      preLoaderRoute: typeof ArcSipCallCallingRouteRouteImport
      parentRoute: typeof ArcSipCallRouteRoute
    }
  }
}

interface ArcSipCallRouteRouteChildren {
  ArcSipCallCallingRouteRoute: typeof ArcSipCallCallingRouteRoute
  ArcSipCallAvailableRoute: typeof ArcSipCallAvailableRoute
}

const ArcSipCallRouteRouteChildren: ArcSipCallRouteRouteChildren = {
  ArcSipCallCallingRouteRoute: ArcSipCallCallingRouteRoute,
  ArcSipCallAvailableRoute: ArcSipCallAvailableRoute,
}

const ArcSipCallRouteRouteWithChildren = ArcSipCallRouteRoute._addFileChildren(
  ArcSipCallRouteRouteChildren,
)

interface ArcSipRouteChildren {
  ArcSipAdminRouteRoute: typeof ArcSipAdminRouteRoute
  ArcSipCallRouteRoute: typeof ArcSipCallRouteRouteWithChildren
  ArcSipProfileRouteRoute: typeof ArcSipProfileRouteRoute
  ArcSipStatisticsRouteRoute: typeof ArcSipStatisticsRouteRoute
}

const ArcSipRouteChildren: ArcSipRouteChildren = {
  ArcSipAdminRouteRoute: ArcSipAdminRouteRoute,
  ArcSipCallRouteRoute: ArcSipCallRouteRouteWithChildren,
  ArcSipProfileRouteRoute: ArcSipProfileRouteRoute,
  ArcSipStatisticsRouteRoute: ArcSipStatisticsRouteRoute,
}

const ArcSipRouteWithChildren =
  ArcSipRoute._addFileChildren(ArcSipRouteChildren)

interface ArcRouteRouteChildren {
  ArcOfflineRouteRoute: typeof ArcOfflineRouteRoute
  ArcSipRoute: typeof ArcSipRouteWithChildren
  ArcIndexRoute: typeof ArcIndexRoute
}

const ArcRouteRouteChildren: ArcRouteRouteChildren = {
  ArcOfflineRouteRoute: ArcOfflineRouteRoute,
  ArcSipRoute: ArcSipRouteWithChildren,
  ArcIndexRoute: ArcIndexRoute,
}

const ArcRouteRouteWithChildren = ArcRouteRoute._addFileChildren(
  ArcRouteRouteChildren,
)

interface AuthRouteRouteChildren {
  AuthResetPasswordRouteRoute: typeof AuthResetPasswordRouteRoute
  AuthSignInRouteRoute: typeof AuthSignInRouteRoute
  AuthSignUpRouteRoute: typeof AuthSignUpRouteRoute
  AuthCallbackMicrosoftRoute: typeof AuthCallbackMicrosoftRoute
}

const AuthRouteRouteChildren: AuthRouteRouteChildren = {
  AuthResetPasswordRouteRoute: AuthResetPasswordRouteRoute,
  AuthSignInRouteRoute: AuthSignInRouteRoute,
  AuthSignUpRouteRoute: AuthSignUpRouteRoute,
  AuthCallbackMicrosoftRoute: AuthCallbackMicrosoftRoute,
}

const AuthRouteRouteWithChildren = AuthRouteRoute._addFileChildren(
  AuthRouteRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  ArcRouteRoute: ArcRouteRouteWithChildren,
  AuthRouteRoute: AuthRouteRouteWithChildren,
  DashboardRouteRoute: DashboardRouteRoute,
  R404Route: R404Route,
  MonitorRoute: MonitorRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
